import { Injectable } from '@angular/core';

export type GlsIcon = {
	type: 'svg' | 'png' | 'jpg';
	slug: string;
	width: number;
	height: number;
	srcset?: ('1x' | '2x' | '3x' | '4x')[];
};

const iconsSvg64x64 = [
	'csomagolas-belso',
	'csomagolas-cimzes',
	'csomagolas-csomagpont',
	'csomagolas-dimenziok',
	'csomagolas-karton',
	'csomagolas-kormeret',
	'csomagolas-leghosszabb-oldal',
	'csomagolas-lezart-csomag',
	'csomagolas-nyomasallosag',
	'csomagolas-razkodasallosag',
	'csomagolas-rogzitsd',
	'csomagolas-suly',
	'csomagolas-utesallosag',
	'kalkulator-dimenziok-feher',
	'kalkulator-suly-feher',
];
const iconsSvg48x48 = ['card-accepted', 'card-not-accepted'];
const iconsSvg100x100 = [
	'08-00-service',
	'09-00-service',
	'10-00-service',
	'12-00-service',
	'24-h-transit-time',
	'accepted',
	'additional-services',
	'adressbook-sender',
	'all-in-one-hand',
	'attention',
	'attention2-1',
	'attention2',
	'attention3-1',
	'attention3',
	'authorisation',
	'automotive-car',
	'award',
	'B2B-flyer',
	'B2B-service-portfolio',
	'B2C-flyer',
	'bank',
	'book',
	'branch-solutions',
	'bribery',
	'briefcase',
	'calculator',
	'calendar',
	'camera',
	'card_payment',
	'cargo_bike',
	'carport',
	'cash-service',
	'certificate',
	'chat',
	'clima-neutral',
	'coffee',
	'construction-industry',
	'consumer-goods',
	'contact-global',
	'contact-less',
	'contact-regional',
	'contact',
	'cosignment-service',
	'customer-frequency',
	'customer-loyalty',
	'data-filter',
	'date-of-delivery',
	'delete',
	'delivery_to_parcelbox',
	'delivery-at-work-service',
	'delivery-at-work',
	'delivery-options',
	'development',
	'dice',
	'digital-handling',
	'document',
	'download-document',
	'ecommerce-integration',
	'eDeclaration-service',
	'electric_limousinen',
	'electric_van',
	'embargos-sanctions',
	'equipment',
	'error',
	'error2-1',
	'error2',
	'error3-1',
	'error3',
	'European-network',
	'evening',
	'exchange-service',
	'export-guideline',
	'express-delivery',
	'extra-income',
	'flag',
	'flex-delivery-service',
	'flexible-solutions',
	'flight',
	'food_and_drink',
	'freight',
	'fuel_card',
	'garden1',
	'garden2',
	'garden3',
	'global-delivery',
	'Global-network',
	'gls-app',
	'gls-one',
	'gls-paketshop-contact',
	'gls-paketshop-location',
	'gls-paketshop-tracking',
	'gls-paketshop',
	'gls-parcelshop-contact',
	'gls-parcelshop-location',
	'gls-parcelshop-tracking',
	'gls-parcelshop',
	'guideline-regular-dispatch',
	'guideline-sporadic-dispatch',
	'handed over-document',
	'handicapped',
	'handscanner01',
	'handscanner02',
	'handscanner03',
	'hazardous-goods',
	'heavy-parcels',
	'high-tech',
	'holiday',
	'hotel',
	'Icon designer',
	'ident-pin-age-verify',
	'ident-pin-service',
	'ident-service',
	'inbound-service',
	'info-desk',
	'info-desk2-1',
	'info-desk2',
	'info-desk3-1',
	'info-desk3',
	'information',
	'information2-1',
	'information2',
	'information3-1',
	'information3',
	'insurance',
	'intercompany-service',
	'it-solutions',
	'label',
	'leaving_permission',
	'legal',
	'letterbox-service',
	'linehaul',
	'location-network',
	'location',
	'login',
	'logout',
	'manual',
	'measure',
	'measure2',
	'measure3',
	'meeting',
	'message',
	'modern-technology',
	'money_waste',
	'monitor',
	'no-risk',
	'no-waiting-line',
	'non-conveyable-goods',
	'notebook',
	'one-contact-person',
	'online-signature-recipient',
	'online-signature',
	'opening-hours',
	'packaging-tipps',
	'paperless',
	'parcel_think-green',
	'parcel-locker',
	'partner-network-world-wide',
	'passport',
	'payment-options',
	'pbs',
	'personal-attention',
	'personal-delivery',
	'pharma-healthcare',
	'pharma-service',
	'pick-and-ship-service',
	'piggy-bank',
	'postbox',
	'price-overview',
	'print_V2',
	'print-document',
	'project',
	'provision',
	'quality',
	'reasonable-rates',
	'recipient-address',
	'redirection',
	'rental_car',
	'retail',
	'returns-solutions',
	'same-day',
	'saturday-10-service',
	'saturday-12-service',
	'saturday-service',
	'save_data',
	'save1',
	'save2',
	'save3',
	'scale',
	'scannen',
	'security',
	'selection-services',
	'service-hotline',
	'settings',
	'ship',
	'shipment_accepted',
	'shipping-volume-pharma',
	'shop-contact',
	'shop-delivery-service',
	'shop-lcoation',
	'shop-return',
	'shopping-cart',
	'short-distances',
	'short-transit-times',
	'signature',
	'smartphone-QR',
	'smartphone',
	'social',
	'special-services',
	'start_video',
	'tablet',
	'timewindow',
	'tires',
	'track-and-trace',
	'tracking_2nd-delivery-attempt',
	'tracking-canceled',
	'tracking-delivered',
	'tracking-delivery-failed',
	'tracking-depot',
	'tracking-in-delivery-insured',
	'tracking-in-delivery',
	'tracking-parcel',
	'tracking-preadvice',
	'tracking-retouring',
	'tracking-shop',
	'tracking-van-in-delivery',
	'train',
	'transmitted',
	'truck',
	'unlimited-shipping',
	'update2',
	'value-added-services',
	'van-express',
	'van',
	'welcome',
	'your-gls',
];

const GLS_ICONS: Record<GlsIcon['slug'], GlsIcon> = {
	...Object.fromEntries(iconsSvg64x64.map(slug => [slug as GlsIcon['slug'], { slug, type: 'svg', width: 64, height: 64 } as GlsIcon])),
	...Object.fromEntries(iconsSvg48x48.map(slug => [slug as GlsIcon['slug'], { slug, type: 'svg', width: 48, height: 48 } as GlsIcon])),
	...Object.fromEntries(iconsSvg100x100.map(slug => [slug as GlsIcon['slug'], { slug, type: 'svg', width: 100, height: 100 } as GlsIcon])),

	// custom icons
	'first-mile-PS': { type: 'svg', slug: 'first-mile-PS', width: 180, height: 100 },
};

const baseUrl = '';

@Injectable({
	providedIn: 'root',
})
export class GlsIconRepository {
	public getIconSrcset(slug: keyof typeof GLS_ICONS): string[] {
		const icon = GLS_ICONS[slug];
		return (icon.srcset || []).map(size => `${baseUrl}/assets/img/content/icons/${icon.slug}${size === '1x' ? '' : `@${size}`}.${icon.type}${size === '1x' ? '' : ` ${size}`}`);
	}

	public getIconUrl(slug: keyof typeof GLS_ICONS): { src: string; srcset?: string } | null {
		const icon = GLS_ICONS[slug];
		return icon
			? {
					src: `${baseUrl}/assets/img/content/icons/${icon.slug}.${icon.type}`,
					srcset: icon.srcset ? this.getIconSrcset(slug).join(', ') : '',
			  }
			: null;
	}

	public fitStyle(slug: keyof typeof GLS_ICONS, { width, height }: { width: number; height: number }): object {
		const icon = GLS_ICONS[slug];
		if (icon) {
			const z = Math.min(width / icon.width, height / icon.height);
			return {
				position: 'relative',
				width: `${Math.floor(icon.width * z)}px`,
				height: `${Math.floor(icon.height * z)}px`,
				top: `${(height - Math.floor(icon.height * z)) / 2}px`,
				left: `${(width - Math.floor(icon.width * z)) / 2}px`,
			};
		} else {
			return {};
		}
	}
}
